import {
  IconNameEnum,
  useCheckoutStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreCheckoutComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ContactInformationReview.module.scss";

const ContactLabelValue = ({
  label,
  value,
  onEdit,
}: {
  label: string;
  value: string;
  onEdit?: () => void;
}) => {
  const COMPONENT_KEY = CoreCheckoutComponent.ContactInformationReview;
  const styles = useCheckoutStyles(COMPONENT_KEY, defaultStyles);
  const [_, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  return (
    <div className={cn("info-container")}>
      <div className={cn("label")}>{label}</div>
      <div className={cn("value")}>{value}</div>
      {onEdit != null ? (
        <button className={cn("edit-button")} onClick={onEdit}>
          <Icon iconName={IconNameEnum.edit} /> <span>{t("edit")}</span>
        </button>
      ) : null}
    </div>
  );
};

export interface ContactInformationReviewComponentProps
  extends PlatformComponentProps {
  email: string;
  phone: string;
  onEmailEditClick?: () => void;
  onPhoneEditClick?: () => void;
}
export const ContactInformationReview = ({
  className,
  email,
  phone,
  onEmailEditClick,
  onPhoneEditClick,
}: ContactInformationReviewComponentProps) => {
  const COMPONENT_KEY = CoreCheckoutComponent.ContactInformationReview;
  const styles = useCheckoutStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  return (
    <div className={clsx(block, className)}>
      <div className={cn("header-container")}>
        <div className={cn("title")}>
          {t("core-checkout.contactInformation.title")}
        </div>
        <div className={cn("subtitle")}>
          {t("checkoutSection.contactInformation.subtitle")}
        </div>
      </div>

      <ContactLabelValue
        label={t("email")}
        value={email}
        onEdit={onEmailEditClick}
      />
      <ContactLabelValue
        label={t("phone")}
        value={phone}
        onEdit={onPhoneEditClick}
      />
    </div>
  );
};
